import { userService } from "./user";

export const getHashValue = (): string => new URLSearchParams(window.location.search).get("hashId") || "";

const jusCan = (
  permissions: Array<string>,
  accountId: string = getHashValue()
): boolean => {
  const permissionsWithAccId = permissions.map(
    (x: string) => `${accountId}.${x.toString()}`
  );
  return userService.can(permissionsWithAccId);
};

export default jusCan;
